import { Component, Inject } from '@angular/core';
import { LoggerService } from '../../core/logger.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Base64Service } from '../../core/base64.service';
import { ApiService } from '../../core/api.service';
@Component({
    selector: 'sync-forgot-password',
    templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent {
    public validEmail = false;

    public hasReset = false;
    public hasHint = false;
    public resetSuccess = false;
    public sendsuccess  = false;

    public emailCheckSpinner = false;

    public resetSpinner = false;
    public hintSpinner = false;

    public resetCode: string;
    public errors: Array<sync.IErrorCode>;

    forgotpasswordForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });

    constructor(
        private base64Service: Base64Service,
        private Logger: LoggerService,
        private apiService: ApiService
    ) { }

    public async checkMethods(e) {
        e.preventDefault();
        this.forgotpasswordForm.get('email').markAsTouched();
        if (this.forgotpasswordForm.valid) {

            try {
                this.emailCheckSpinner = true;
                const emailB64 = this.base64Service.encode(this.forgotpasswordForm.value.email.toLowerCase());
                const result = await this.getPasswordForgotList(emailB64);
                this.hasHint = (result.has_passwordhint > 0);
                this.hasReset = (result.has_passwordreset > 0);
            } catch (err) {
                this.handleErr(err);
            } finally {
                this.validEmail = true;
                this.emailCheckSpinner = false;
            }


        } else {
            this.forgotpasswordForm.get('email').markAsTouched();
            this.forgotpasswordForm.get('email').updateValueAndValidity();
        }

    }

    public async getPasswordForgotList(emailB64: string): Promise<any> {
        return await this.apiService.send('userpasswordforgotlist', {
            email_b64: emailB64
        });
    }


    public async emailResetSubmit() {
        this.resetSuccess = false;
        this.resetSpinner = true;
        this.errors = [];
        const response =  await this.requestPasswordReset(this.forgotpasswordForm.value.email);
        this.resetSuccess = true;
        this.resetCode = response.code;
        this.resetSpinner = false;
    }

    public async requestPasswordReset(email: string): Promise<any> {
        return await this.apiService.send('requestpassreset', {email: email});
    }

    public async emailHintSubmit() {
        this.sendsuccess = false;
        this.hintSpinner = true;
        this.errors = [];
        const response = await this.requestPasswordHint(this.forgotpasswordForm.value.email).catch(err => this.handleErr(err));
        this.hintSpinner = false;
        this.sendsuccess = true;
    }

    public async requestPasswordHint(email: string): Promise<any> {
        return await this.apiService.send('requesthint', { email: email });
    }

    private handleErr(data: any) {
        if (data && data.error_code) {
            this.errors.push({code: data.error_code});
        } else {
            this.errors.push({code: 9000, msg: 'An error occurred sending your forgot password email'});
        }
        this.Logger.error(data);
        this.resetSpinner = false;
        this.sendsuccess = false;
    }
}
